import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import("@pages/root/root.routes").then(m => m.ROOT_ROUTES),
    canActivate: [AuthGuard(true)],
  },
  {
    path: 'auth',
    loadChildren: () => import("@pages/auth/auth.routes").then(m => m.AUTH_ROUTES),
    canActivate: [AuthGuard(false)],
  },
  {
    path: 'auth-sso',
    loadChildren: () => import("@pages/auth/auth.routes").then(m => m.AUTH_ROUTES),
    canActivate: [AuthGuard(false)],
  },
  {
    path: '**',
    redirectTo: '',
    // loadComponent: () => import("@pages/not-found/not-found.component").then(m => m.NotFoundComponent)
  }
];
